//#region Styles
import { Title, HeaderTop } from "./styles";
//#endregion
//#region Components
import DropDownButton from "components/DropDownButton/DropDownButton";
import Filters from "../Filters/Filters";
//#endregion
//#region Utils
import {
	CREATE_EVENT_DROPDOWN_OPTIONS
} from "../../../utils/constants";
//#endregion

const ListHeader = ({
	isTeacherUser,
	filters,
	fillEventList,
	resetCurrentPage,
	currentTabIdx,
	hasReportWaitlist
}) => {
	return (
		<header>
			<HeaderTop>
				<Title>Eventos</Title>
				{!isTeacherUser && (
					<DropDownButton
						{...CREATE_EVENT_DROPDOWN_OPTIONS}
					/>
				)}
			</HeaderTop>
			<Filters
				isTeacherUser={isTeacherUser}
				currentTabIdx={currentTabIdx}
				filters={filters}
				resetCurrentPage={resetCurrentPage}
				fillEventList={fillEventList}
				hasReportWaitlist={hasReportWaitlist}
			/>
		</header>
	);
};

export default ListHeader;
